import React, { useState } from "react";
import { Checkbox } from "@vds/checkboxes";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";

function CustomFiosModal({
  onClick = () => { },
  onClose = () => { },
  opened = false
}) {
  const [isChecked, setChecked] = useState(false);

  function handlePrimary() {
    try {
      if (isChecked) {
        setChecked(false);
        onClick();
      }
    } catch (e) {
      console.error(e);
    }
  }
  function handleClose() {
    try {
      setChecked(false);
      onClose();
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <Modal
      opened={opened}
      surface="light"
      disableOutsideClick={true}
      ariaLabel="CustomFiosModal"
    >
      <ModalTitle>
      <div className="modal_header"><h5 className="margin-top-zero">Upgrade to Fios TV+</h5></div>
      </ModalTitle>
      <ModalBody>
          <div className="modal_content padding-all-tiny">
            <p className="text-small margin-bottom-tiny">Includes the following features</p>
                <ul><li>Home page that includes live TV, On Demand, and content from your favorite streaming services all in one place.</li><li>Content organized into rows for easy navigation (in addition to the traditional channel guide).</li><li>Access to the full inventory of Google Play Store apps.</li><li>Watch 4K video on the Fios TV+ box. (4K-capable TV is required.)</li><li>Bluetooth remote that allows you to change the channel without having to directly point at the screen.</li><li>Google Assistant button on the remote lets you use your voice to search across live TV, On Demand, and your streaming services.</li></ul>
          </div>
          <div className="m_tall">
                <img src={require('./../../assets/ak-cached/24h/img/fiostvplus.png').default} alt="Equipment" style={{ 'width': '300px', 'marginLeft':'5rem', 'marginBottom': '2rem' }} />
          </div>
            
      </ModalBody>
      <ModalFooter
        buttonData={{

          close: {
            children: 'Continue',
            onClick: (e) => handleClose(e),
          },
        }}
      />
    </Modal>
  );
}

export default CustomFiosModal;
